export default __webpack_public_path__ + "static/media/lines.left.c1bc3912.png";